import PropTypes from 'prop-types'
import React from 'react'

import { LocalizationContext } from 'contexts/Localization'

import AddressLine from './components/AddressLine'
import { H2Styled, TextBox, TextUpperStyled, TitleBox, Wrapper } from './styles'

const AddressCard = ({ titles }) => {
  const { dict } = React.useContext(LocalizationContext)

  return (
    <Wrapper>
      <TextBox>
        <TextUpperStyled dangerouslySetInnerHTML={{ __html: titles.title }} />
      </TextBox>
      <TitleBox>
        <H2Styled
          as="h1"
          dangerouslySetInnerHTML={{ __html: dict.info.address }}
        />
      </TitleBox>
      {dict.phone.value
        ? null
        : /* <AddressLine
          link={`tel:${dict.phone.link}`}
          title={titles.call_us}
          value={dict.phone.value}
        />
        /> 
        TODO: BRING IT BACK WHEN WE ARE ALIVE 100% */

          null}
      {dict.email.value ? (
        <AddressLine
          link={`mailto:${dict.email.value}`}
          title={titles.write_us}
          value={dict.email.value}
        />
      ) : null}
    </Wrapper>
  )
}

AddressCard.propTypes = {
  titles: PropTypes.object,
}

AddressCard.defaultProps = {
  titles: {},
}

export default AddressCard
